import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

export default function ActionButton({
  buttonText,
  disabledClasses,
  isDisabled = false,
  onClick,
  style = {},
  styleClasses = 'tw-border-0 tw-inline-flex tw-cursor-pointer tw-select-none tw-items-center tw-rounded-lg tw-h-10 tw-px-5 tw-py-0 tw-font-inter tw-text-m tw-font-medium tw-tracking-auto tw-shadow-none tw-transition-all tw-duration-200 tw-ease-in disabled:tw-opacity-30 disabled:tw-pointer-events-none data-[disabled=true]:tw-opacity-30 data-[disabled=true]:tw-pointer-events-none',
}) {
  return (
    <button
      className={classNames(
        'tw-font-medium',
        styleClasses,
        isDisabled && disabledClasses,
      )}
      disabled={isDisabled}
      onClick={onClick}
      style={style}
    >
      <div className='tw-m-0'>{buttonText}</div>
    </button>
  );
}

ActionButton.propTypes = {
  buttonText: PropTypes.string,
  disabledClasses: PropTypes.string,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
  styleClasses: PropTypes.string,
};
